import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'mbnm-order-progress',
  templateUrl: './order-progress.component.html',
  styleUrls: ['./order-progress.component.scss'],
  host: {
    '[class.disabled]': 'this.order.Status === "CANCELLED"'
  }
})
export class OrderProgressComponent implements OnInit {

  constructor() { }

  steps:Array<any> = [
    {label: 'order received'},
    {label: 'sent to fulfillment'},
    {label: 'processing order'},
    {label: 'order shipped'}
    ];
  compPercent:number = 0;

  @Input()
  order:any;

  ngOnInit() {
    const CHECKED_CLASS = 'checkbox-marked-circle';
    const UNCHECKED_CLASS = 'circle-outline';

    this.steps.forEach( (step, idx) => {
      step.color = 'primary'
      switch (this.order.Status) {
        case 'SHIPPED':
        case 'DELIVERED':
          step.className = CHECKED_CLASS;
          break;
        case 'PROCESSING':
          if (idx < 3) {
            step.className = CHECKED_CLASS;
          } else {
            step.className = UNCHECKED_CLASS;
          }
          break;
        case 'READY':
          if (idx < 2) {
            step.className = CHECKED_CLASS;
          } else {
            step.className = UNCHECKED_CLASS;
          }
          break;
        case 'NEW':
          if (idx < 1) {
            step.className = CHECKED_CLASS;
          } else {
            step.className = UNCHECKED_CLASS;
          }
          break;
        case 'HOLD':
        case 'PRODUCTION-HOLD':
          if (idx == 0) {
            step.className = CHECKED_CLASS;
          } else {
            step.className = 'pause-circle';
            step.color = 'secondary'
          }
          break;
        case 'CANCELLED':
          if (idx == 0) {
            step.className = CHECKED_CLASS;
          } else {
            step.className = 'minus-circle';
            step.color = 'warn'
          }
          break;
      }
    });

    switch (this.order.Status) {
      case 'SHIPPED':
      case 'DELIVERED':
        this.compPercent = 100;
        break;
      case 'PROCESSING':
        this.compPercent = 66.66;
        break;
      case 'READY':
        this.compPercent = 33.33;
        break;
      case 'NEW':
      case 'HOLD':
      case 'PRODUCTION-HOLD':
        this.compPercent = 1;
        break;
    }
  }
}
